import type { ReactNode } from 'react';
import type { IconName } from '../icons';
import { Icon } from './Icon';

// Empty / guarded state: icon tile · title · one sentence · one primary action (Authority §26).
export function EmptyState(props: { title: string; body: string; icon?: IconName; action?: ReactNode; testId?: string }) {
  return (
    <div className="empty-state" data-testid={props.testId}>
      {props.icon ? (
        <span className="icon-tile empty-state-icon">
          <Icon name={props.icon} />
        </span>
      ) : null}
      <p className="empty-state-title">{props.title}</p>
      <p className="empty-state-body">{props.body}</p>
      {props.action ? <div className="empty-state-action">{props.action}</div> : null}
    </div>
  );
}
